(function () {
  var $ = function (s) { return document.querySelector(s); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  /* Wejście: kurtyna tylko raz na sesję */
  var curtain = $('#curtain'), seen = false;
  try { seen = sessionStorage.getItem('squish-intro'); } catch (e) {}
  if (!curtain || seen || reduce) { if (curtain) curtain.remove(); body.classList.add('ready'); }
  else {
    setTimeout(function () { curtain.classList.add('go'); }, 1500);
    setTimeout(function () { body.classList.add('ready'); }, 1900);
    try { sessionStorage.setItem('squish-intro', '1'); } catch (e) {}
  }

  /* Litery napisu */
  var word = $('#word'), inner = [];
  if (word) {
    var cols = ['#F77FB0', '#E58CD0', '#B594F2', '#8DA6F5', '#6FC3E8', '#5FD1B0'];
    var t = word.textContent.trim();
    word.setAttribute('aria-label', t);
    word.innerHTML = '';
    t.split('').forEach(function (ch, i) {
      var l = document.createElement('span'); l.className = 'l'; l.setAttribute('aria-hidden', 'true');
      l.style.setProperty('--i', i); l.style.color = cols[i % cols.length];
      var s = document.createElement('span'); s.textContent = ch; l.appendChild(s);
      word.appendChild(l); inner.push(s);
    });
  }

  /* Pojawianie się przy scrollu */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .15 });
  document.querySelectorAll('.rv').forEach(function (el) {
    el.style.transitionDelay = ([].indexOf.call(el.parentElement.children, el) % 4) * 90 + 'ms';
    io.observe(el);
  });

  /* Gniecenie liter i ruch teł przy scrollu */
  if (!reduce) {
    var blobs = [].slice.call(document.querySelectorAll('.bg'));
    var last = scrollY, s = 0;
    (function loop() {
      var y = scrollY, d = y - last; last = y;
      s += (Math.min(Math.abs(d) / 40, .5) - s) * .14;
      inner.forEach(function (el, i) {
        el.style.transform = 'scale(' + (1 + s * .55 * (1 - i * .05)) + ',' + (1 - s * .7 * (1 - i * .05)) + ')';
      });
      blobs.forEach(function (b) { b.style.transform = 'translateY(' + (y * b.dataset.s) + 'px)'; });
      requestAnimationFrame(loop);
    })();
  }

  /* Koszyk bez przeładowania strony */
  var tt;
  function toast(m) { var e = $('#toast'); e.textContent = m; e.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { e.classList.remove('show'); }, 2200); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    fetch(window.SQ.add, { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return fetch(window.SQ.cart); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = $('#count'); n.textContent = c.item_count;
        var b = $('#cart'); b.classList.add('pop'); setTimeout(function () { b.classList.remove('pop'); }, 250);
        toast('Dodano do koszyka: ' + (f.dataset.name || ''));
      })
      .catch(function () { f.submit(); });
  });
})();
